import { getLocalAccessToken } from "../../utils/helper";
import api, {
  handleErrorCreateAndUpdate,
  handleErrorShowCache,
} from "../../services/api";
import { Toast } from "../../components/notify/Notify";
import { url } from "../../constants/path";
const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.flfCustomer;

export const getFLFCustomer = (params = {}, callback) => {
  api
    .get(URL, { params })
    .then((response) => callback(response.data.data))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const syncDataFLFCustomer = (data, callback) => {
  api
    .patch(`${URL}/profile/sync`, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const showDeviceForCustomer = (data, callback) => {
  api
    .patch(`${URL}/profile/display-devices`, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getFLFCustomerDetail = (id, callback) => {
  api
    .get(`${URL}/sync-status/${id}`)
    .then((response) => {
      callback(response.data.data);
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const updateFLFCustomer = (id, data, callback) => {
  api
    .patch(`${URL}/change-status/${id}`, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      handleErrorCreateAndUpdate(err, callback);
    });
};

export const getCacheFLFCustomer = (callback) => {
  api
    .get(`${URL}/cache`)
    .then((response) => {
      callback(response.data.data);
    })
    .catch((err) => {
      handleErrorShowCache(err);
    });
};

export const clearCacheFLFCustomer = (callback) => {
  api
    .post(`${URL}/clear-cache`)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const deployCacheFLFCustomer = (callback) => {
  api
    .post(`${URL}/deploy-cache`)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};
